import { t } from '@ankr.com/common';

import { root } from '../../../const';

export const renderSuiMainnetTitle = (url: string) => {
  const isGraphql = url.includes('graphql');

  if (isGraphql) {
    return t(`${root}.endpoints.graphql-title`);
  }

  return t(`${root}.endpoints.https-title`);
};
